import React, { useEffect, useState } from "react";
import * as cls from "./academicDebts.module.scss";
import ListItem from "../../resources/icons/ListItem";
import {
  ErrataView,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Table } from "../../components/tableLoader";
import { StudentService } from "../../components/studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";

export default function AcademicDebts() {
  const [data, setData] = useState(null);
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [errorMessage, setErrorMessage] = useState("");
  async function getAcademicDebt() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/widget/academic_debt",
        data: {
          access_token,
          study_contract_id: contractId,
          return_row_value: 0,
        },
      };
      setErrorMessage(null);
      setData(null);
      await StudentService.send(request, (response) => {
        if (response) {
          setErrorMessage(response);

          if (!response.errors) {
            response.columns = response.columns.filter(
              (col) =>
                col.field === "cur_discip_name" || col.field === "module_name",
            );
            response.columns.unshift({ field: "" });
            response.rows = response.rows.map((row, i) => ({
              ...row,
              "": i + 1,
            }));
            setData(response);
          } else if (response.error_type !== "info") {
            const errorEvent = new ErrorEvent("error", { error: response });
            window.dispatchEvent(errorEvent);
          }
        }
      });
    }
  }

  useEffect(() => {
    getAcademicDebt();
  }, [access_token, contractId]);

  if (errorMessage?.errors) {
    return (
      <WidgetFrame
        type="magenta"
        icon="folder_open"
        title=" Перечень академических задолженностей"
      >
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </WidgetFrame>
    );
  }
  return (
    <WidgetFrame
      type="magenta"
      icon="folder_open"
      title=" Перечень академических задолженностей"
    >
      <Table {...data} />
      <p className={cls.academicDebts_info}>
        Информируем обучающихся о том, что в соответствии с ч.3 ст.58 ФЗ №273_ФЗ
        “Об образовании в Российской Федерации” Вам необходимо ликвидировать
        академическую задолженность. В соответствии с ч.5 ст.58 ФЗ “Об
        образовании в Российской Федерации” Вы вправе пройти промежуточную
        аттестацию по указанным выше дисциплинам (практикам) не более двух раз в
        сроки, определяемые образовательной организацией.
      </p>
      <br />
      <p className={cls.academicDebts_info}>
        Обучающиеся могут быть допущены к итоговой аттестации после полного
        успешного выполнения учебного плана.
      </p>
    </WidgetFrame>
  );
}
